import { db } from "../../firebase";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
} from "firebase/firestore";

export const TaskCommentsService = {
  subscribe(companyId, taskId, onItems, onError) {
    if (!companyId || !taskId) return () => {};

    const ref = collection(db, "companies", companyId, "tasks", taskId, "comments");
    const q = query(ref, orderBy("createdAt", "asc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        onItems?.(items);
      },
      (err) => {
        console.error("[TaskCommentsService] subscribe error:", err);
        onError?.(err);
      }
    );

    return unsub;
  },

  async addComment(companyId, taskId, data) {
    if (!companyId || !taskId) throw new Error("Missing companyId/taskId.");

    // ✅ RULES-FRIENDLY REQUIRED FIELDS
    const payload = {
      companyId: companyId,
      entityType: "task",
      entityId: taskId,

      text: String(data?.text || "").trim(),
      textPlain: String(data?.textPlain || "").trim(),

      mentionedUserIds: Array.isArray(data?.mentionedUserIds) ? data.mentionedUserIds : [],

      createdBy: data?.createdBy || null,
      createdByName: data?.createdByName || null,
      createdByRole: data?.createdByRole || null,

      createdAt: serverTimestamp(),
    };

    if (!payload.text) throw new Error("Comment text is required.");
    if (!payload.createdBy) throw new Error("Missing createdBy (uid).");

    const ref = collection(db, "companies", companyId, "tasks", taskId, "comments");
    const docRef = await addDoc(ref, payload);
    return docRef.id;
  },

  async deleteComment(companyId, taskId, commentId) {
    if (!companyId || !taskId || !commentId) throw new Error("Missing ids for delete.");
    const ref = doc(db, "companies", companyId, "tasks", taskId, "comments", commentId);
    await deleteDoc(ref);
  },
};
